import { render, staticRenderFns } from "./LogisticServicePriceModal.vue?vue&type=template&id=14aac7ad&scoped=true&"
import script from "./LogisticServicePriceModal.vue?vue&type=script&lang=js&"
export * from "./LogisticServicePriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aac7ad",
  null
  
)

export default component.exports